// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Menu-module--cls1--3Xdf7","cls2":"styles-Menu-module--cls2--1qFY7 styles-Menu-module--cls1--3Xdf7"};